'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const FileTileThumbnail = renderWithRef('FileTileThumbnail', null, (o, i)=>{
    let { children: l } = o, c = _object_without_properties(o, [
        "children"
    ]);
    return jsxs(RenderComp, {
        classNames: new Set([
            'swan-file-tile-thumbnail'
        ]),
        root: "div",
        forwardedRef: i,
        props: _object_spread({}, c),
        children: [
            l ? jsx("div", {
                className: "swan-file-tile-thumbnail-image-container",
                children: l
            }) : null,
            jsx(Icon, {
                className: "swan-file-tile-icon",
                iconType: "fileGeneric"
            }),
            jsx(Icon, {
                className: "swan-file-tile-icon-error",
                iconType: "error",
                skin: "error"
            })
        ]
    });
});

export { FileTileThumbnail };
